<template>
  <v-list dense>
    <v-list-item
      v-for="item in computedActions"
      :key="item.name"
      class="action-element px-2"
      :class="item.active ? 'active' : ''"
      style="height: 45px"
    >
      <v-list-item-content @click="emitAction(item)">
        <v-list-item-title
          :title="item.name"
          v-text="item.name"
          class="text-body-2 font-weight-regular"
          :class="item.active ? 'activeText' : ''"
        />
      </v-list-item-content>
      <v-list-item-action>
        <dots-menu
          font-size="19px"
          :items="[{ name: 'edit' }, { name: 'delete' }]"
          @delete="showDelete(item)"
          @edit="showEditName(item)"
        ></dots-menu>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'ZDMActionList',
  components: {
    DotsMenu,
  },
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    activeItemId: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    showDelete(item) {
      this.$emit('actionDelete', item.id);
    },
    showEditName(item) {
      this.$emit('actionEdit', item.id);
    },
    emitAction(item) {
      this.$emit('actionSelected', item.id);
    },
  },
  computed: {
    computedActions() {
      return this.actions.map((value, index) => {
        return {
          ...value,
          index: index,
          active: value.id === this.activeItemId,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.action-element {
  @include border();
  text-align: left;
  &:hover {
    background-color: rgba(188, 188, 188, 0.2);
    cursor: pointer;
  }
  &.active {
    background: hsla(214, 82%, 50%, 0.08);
    &:hover {
      background-color: hsla(214, 82%, 50%, 0.16);
    }
  }
}

.activeText {
  color: #1a73e8;
}
</style>
